import React from "react";
import "../NFTDetailDesign.css";
import { formatTime, SpinnerLoader } from "../../../utils/utils";
import LoadingError from "../Comment/LoadingError";
import DetailsSkelon from "./DetailsSkelon";


const Details = ({ nftDetailObject, nftLoading, nftLoadingError }) => {

    return (
        <div
            className="tab-pane fade"
            id="details"
            role="tabpanel"
            aria-labelledby="details-tab"
        >
            {
                nftLoading === true ? (
                    <SpinnerLoader></SpinnerLoader>
                ) : nftLoadingError ? (
                    <LoadingError
                        title="Unable to Load NFT Details"
                        message="Something went wrong while loading the details. Please check your connection and try again."
                        retry={false}
                    />

                ) : (
                    <>

                        <div className="mb-3">
                            <label className="form-label CeraBold d-block">Description</label>
                            <p className="mb-0">
                                {nftDetailObject?.description}
                            </p>
                        </div>

                        {nftDetailObject?.properties &&
                            Object.values(nftDetailObject?.properties).some((val) => val) && (
                                <div className="mb-3">
                                    <label className="form-label CeraBold d-block">Attributes</label>
                                    <div className="NFTDetailDesign__attributes d-flex flex-wrap gap-3">
                                        <div className="NFTDetailDesign__attr enhanced-tile">
                                            {Object.values(nftDetailObject?.properties).map(
                                                (value, i) =>
                                                    value && (
                                                        <div key={i} className="fw-semibold text-capitalize attr-line">
                                                            {value}
                                                        </div>
                                                    )
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}

                        <div className="row g-3">
                            <div className="col-6 col-md-4">
                                <div className="small text-secondary">Blockchain</div>
                                <div className="fw-semibold">Substrate</div>
                            </div>
                            <div className="col-6 col-md-4">
                                <div className="small text-secondary">Created At</div>
                                <div className="fw-semibold">{formatTime(nftDetailObject?.timestamps?.created_At)}</div>
                            </div>
                            <div className="col-6 col-md-4">
                                <div className="small text-secondary">Creator Royalties</div>
                                <div className="fw-semibold">{nftDetailObject?.royalties}%</div>
                            </div>
                        </div>
                    </>
                )
            }
        </div>
    );
};

export default Details;